import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import HeroImage from "../styles/images/hero-image.png";
import CorporateImage from "../styles/images/corporate.png";
import SupportImg from "../styles/images/Supports.png";
import Invoices from "../styles/images/Invoices.png";
import MapImage from "../styles/images/map.svg";
import CallIcon from "../styles/images/call.svg";
import AboutUsGif from "../styles/images/about-us.gif";
import CarSvg from "../styles/images/car.svg";
import Footer from "../components/Footer";
import emailjs from "emailjs-com";
import { useRef } from "react";
import Swal from "sweetalert2";

export default function HomePage() {
  const formRef = useRef();
  const [errors, setErrors] = useState({});
  //const [fileName, setFileName] = useState("");
  const [loading, setLaoding] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const validateForm = () => {
    const form = formRef.current;
    const newErrors = {};

    if (!form.from_name.value.trim()) {
      newErrors.from_name = "Name is required";
    }

    if (!/^[0-9]{10}$/.test(form.mobile.value)) {
      newErrors.mobile = "Enter valid 10-digit number";
    }

    if (!form.message.value.trim()) {
      newErrors.message = "Message is required";
    }

    /*if (!form.attachment.files.length) {
      newErrors.attachment = "Please attach a file";
    }*/

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const clearError = (field) => {
    setErrors((prev) => {
      const updated = { ...prev };
      delete updated[field];
      return updated;
    });
  };

  const sendEmail = (e) => {
    e.preventDefault();

    if (!validateForm()) return;
    setLaoding(true);
    emailjs
      .sendForm(
        "service_ddda8h8",
        "template_ou3kct9",
        formRef.current,
        "Pu19HXA_DU15tlv3t",
      )
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Request Sent!",
          text: "We will contact you shortly.",
          confirmButtonColor: "#13E400",
        });
        formRef.current.reset();
        setLaoding(false);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops!",
          text: "Something went wrong. Please try again.",
          confirmButtonColor: "#ff4d4f",
        });
        setLaoding(false);
      });
  };

  return (
    <>
      <div className="container">
        <Header />
        <div className="main-area">
          <div className="hero-section-main" id="home">
            <div className="hero-section-content">
              Driven by Technology. Defined by Trust.
            </div>
            <div className="hero-section-subcontent">
              <strong>Apni Gaadi</strong> is India’s next-generation mobility
              platform, blending intelligent technology with human trust.
            </div>
            <div className="hero-section-banner-image">
              <img src={HeroImage} alt="Hero Banner" />
            </div>
          </div>
          <div className="about-us-section" id="about-us">
            <div className="our-mission-content">About Us</div>
            <div className="our-mission-subcontent">
              At <strong>Apni Gaadi</strong>, we are transforming corporate
              mobility across India with a platform built on
              <strong> innovation, reliability, and trust</strong>. Our mission
              is to make <strong>business travel seamless</strong> by offering{" "}
              <strong>smart cab solutions</strong> that combine advanced
              technology with a human touch.
            </div>
            <div className="hero-section-banner-image">
              <img src={AboutUsGif} alt="About Us" />
            </div>
            <div className="our-mission-subcontent">
              We provide organizations and professionals with{" "}
              <strong>dependable rides</strong>, precision-mapped routing, and
              certified vehicles to ensure{" "}
              <strong>safety, comfort, and punctuality</strong>. Beyond serving
              passengers, we are committed to{" "}
              <strong>empowering drivers</strong> through transparent earnings,
              skill development, and sustainable opportunities.
            </div>
            <div className="our-mission-subcontent">
              With a focus on excellence and integrity,{" "}
              <strong>Apni Gaadi</strong> is more than a mobility service —{" "}
              <strong>
                it’s a trusted partner for businesses and individuals who value
                efficiency, security, and convenience
              </strong>
              .
            </div>
          </div>
          <div className="our-mission-section-new" id="mission">
            <div className="our-mission-content">Our Mission</div>
            <div className="our-mission-subcontent">
              <div className="our-mission-content-left">
                Elevating business travel through choice, comfort, and
                precision. As India’s premier mobility platform, we deliver
                tailored corporate cab services designed for the modern
                professional.
                <br />
                Ye <strong>Apni Gaadi</strong>: Reliability in every mile.
              </div>
              <div className="our-mission-content-right">
                <ul>
                  <li>
                    <span>The Shadow Redundancy</span>
                  </li>

                  <li>
                    <span>No Cancellation, 0 Surge</span>
                  </li>

                  <li>
                    <span>Predictive Positioning</span>
                  </li>

                  <li>
                    <span>Wait & Assist</span>
                  </li>
                  <li>
                    <span>Rewards As Per Milestone (upto 4km)</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="divider">Trusted by businesses across India <img src={CarSvg} alt="car svg"/></div>
          <div className="explore-rides-section" id="rides">
            <div className="explore-rides-heading">Explore Our Rides</div>
            <div className="explore-rides-sub-heading">
              Your <strong>APNI GAADI</strong> journey starts here!
            </div>
            <div className="explore-rides-cards-container">
              <div className="ride-card">
                <div className="ride-card-image sedan-image">
                  <img src={CorporateImage} alt="Sedan" />
                </div>
                <div className="ride-card-chips">
                  <div className="ride-card-chip">24 hrs</div>
                  <div className="ride-card-chip">Comfirtable Rides</div>
                </div>
                <div className="ride-card-description-heading">
                  S-Cabin Standard: Scent, Shine, Silence
                </div>
                <div className="ride-card-description">
                  Premium in-ride experience with fresh interiors, spotless
                  vehicles, and noise-controlled comfort. Every trip is designed
                  to feel clean, calm, and consistently high-quality from pickup
                  to drop.
                </div>
              </div>
              <div className="ride-card">
                <div className="ride-card-image sedan-image">
                  <img src={Invoices} alt="Sedan" />
                </div>
                <div className="ride-card-chips">
                  <div className="ride-card-chip">24 hrs</div>
                  <div className="ride-card-chip">GST Invoices</div>
                </div>
                <div className="ride-card-description-heading">
                  Smart B2B Billing: GST-ready automated invoicing
                </div>
                <div className="ride-card-description">
                  Seamless billing for businesses with automated GST-compliant
                  invoices, centralized tracking, and easy expense management.
                  Designed to simplify operations and ensure accuracy for every
                  ride.
                </div>
              </div>
              <div className="ride-card">
                <div className="ride-card-image sedan-image">
                  <img src={SupportImg} alt="Sedan" />
                </div>
                <div className="ride-card-chips">
                  <div className="ride-card-chip">24 hrs</div>
                  <div className="ride-card-chip">Supports</div>
                </div>
                <div className="ride-card-description-heading">
                  Instant SOS: 24/7 human-response emergency support
                </div>
                <div className="ride-card-description">
                  Round-the-clock safety support with instant SOS access, real
                  human assistance, and rapid response coordination. Built to
                  ensure every rider feels secure and supported at all times.
                </div>
              </div>
            </div>
          </div>
          <div className="locations-section" id="locations">
            <div className="locations-heading">
              Apni Gaadi is now available in
            </div>
            <div className="locations-sub-heading">
              <div className="locations-map-image">
                <img src={MapImage} alt="Locations Map" />
              </div>
            </div>
          </div>
          <div className="locations-section" id="contact">
            <div className="contact-heading">We Want to Hear From You!</div>
            <div className="contact-sub-heading">
              <strong>Experience Corporate Mobility, Redefined</strong>. Curious
              about how seamless ride-sharing works? Whether you're optimising
              business travel or seeking India’s most reliable corporate cab
              solutions, we bridge the gap between premium service and
              professional ease. With our elite chauffeur network, every ride
              feels personal. Experience the <strong>Apni Gaadi</strong>{" "}
              confidence today.
            </div>
            <div className="contact-cta-button">
              <div className="address-contact-info">
                <div className="contact-cta-button-text">
                  <div className="address-icon">
                    <img src={CallIcon} alt="Call Icon" />
                  </div>
                  <div className="address-text-call">
                    <div>
                      24×7 Mobility Assistance Powered by smart support and
                      real-time response systems, our service center ensures
                      you’re never left waiting.
                    </div>
                    <div>
                      <strong>Call</strong> 
                      <span style={{ color: "#DBB128" }}>
                      01140847339
                      </span>
                       anytime for instant help — because every ride with Apni
                      Gaadi should feel effortless.
                    </div>
                  </div>
                </div>
              </div>
              <div className="contact-from">
                <form
                  className="callback-request-form"
                  ref={formRef}
                  onSubmit={sendEmail}
                >
                  <input
                    type="text"
                    name="from_name"
                    placeholder="Full Name"
                    className={errors.from_name ? "error" : ""}
                    onChange={() => clearError("from_name")}
                  />
                  <input
                    type="tel"
                    name="mobile"
                    placeholder="Mobile Number"
                    className={errors.mobile ? "error" : ""}
                    inputMode="numeric"
                    pattern="[0-9]{10}"
                    maxLength="10"
                    onChange={() => clearError("mobile")}
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                    }
                  />
                  <textarea
                    name="message"
                    placeholder="Do you have any other preferences and requirements for your ride?"
                    className={errors.message ? "error" : ""}
                    onChange={() => clearError("message")}
                  ></textarea>
                  {/*<div
                    className={`file-upload-section ${
                      errors.attachment ? "error" : ""
                    }`}
                  >
                    <label htmlFor="file-upload" className="custom-file-upload">
                      <span>
                        <img src={FileUploadIcon} alt="File Upload Icon" />
                      </span>{" "}
                      {fileName ? fileName : "Attach Files"}
                    </label>
                    <input
                      id="file-upload"
                      type="file"
                      style={{ display: "none" }}
                      name="attachment"
                      accept=".pdf,.jpg,.png,.doc,.docx"
                      onChange={(e) => setFileName(e.target.files[0]?.name)}
                    />
                  </div>*/}
                  <button type="submit">
                    {loading ? "Submitting..." : "Request a Callback"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
